import React from "react";
import styles from "./Chatbot.module.scss";
import manGenie from "../../assets/images/manGenie.svg";

const ChatHeader = () => {
    return (
      <div className={styles.chatbox__header}>
        <img
          width="64"
          height="64"
          src={manGenie}
          alt="doctor-skin-type-1"
        />
        <div className={styles.chatbox__content__header}>
          <h4 className={styles.chatbox__heading__header}>
            Provider Genie
          </h4>
          <p className={styles.chatbox__description__header}>
            Hi. I'm your genie. How can I help you?
          </p>
        </div>
      </div>
    );
  };
  
export default ChatHeader;